import { IContact } from 'src/api/models/Organization';

/** The subset of a workflow contact DTO this converter reads. */
export interface IWorkflowContactLike {
  id: string;
  name?: string | undefined;
  company?: string | undefined;
  email?: string | undefined;
}

/**
 * Converts a workflow contact DTO (as returned on a workflow record's
 * `submittedToContact`) into the `IContact` shape the `ContactPicker` consumes.
 * Returns null when no contact is selected. When `contactId` is set but the
 * loaded contact does not match it, returns an id-only stub so the selector can
 * resolve the label from its own fetched options.
 */
export const contactDtoToIContact = (
  contact: IWorkflowContactLike | undefined,
  contactId: string | undefined,
): IContact | null => {
  if (!contactId) return null;
  if (contact && contact.id === contactId) {
    return {
      id: contact.id,
      first_name: contact.name ?? '',
      last_name: '',
      phone: '',
      email: contact.email ?? '',
      customer_number: '',
      customer_name: contact.company ?? '',
    };
  }
  return {
    id: contactId,
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    customer_number: '',
    customer_name: '',
  };
};
